import React, { useState } from "react";
import { Button } from "react-bootstrap";
import SocailLinkTable from "../../common/components/SocialLinkTable";

const ManageSocailLinks = () => {
  const [formState, setFormState] = useState("new");

  // table states
  const [page, setPage] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleFormState = (fState, contentId) => {
    setFormState(fState);
  };
  return (
    <div>
      <p></p>
      <div className="card">
        <div className="card-header">
          <strong>Manage Social Media Links</strong>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-2"></div>
            <div className="col">
              <Button size="sm" style={{ float: "right", margin: "5px" }}>
                Add New Social Link
              </Button>
            </div>
          </div>
          <SocailLinkTable
            tableData={[]}
            totalDataLength={0}
            page={page}
            handleChangePage={handleChangePage}
            handleFormState={handleFormState}
            isPendingTable={true}
          />
        </div>
        <p></p>
        <p></p>
      </div>
    </div>
  );
};

export default ManageSocailLinks;
